<template>
  <div>
    <common-dialog
      ref="dialog"
      width="1400px"
      unit="进货单"
      :edit-title="!readonly"
      id-key="commentId"
      form-label-width="110px"
      :data="data"
      :form-rules="rules"
      :get-data-func="api.info"
      :save-func="api.save"
      :before-save="onBeforeSave"
      @create-opened="onCreateOpened"
      @edit-opened="onEditOpened"
      :show-save-button="!readonly"
      :close-on-saved="true"
      @close-saved="$emit('close-saved')"
    >
      <template slot="form">
        <el-button type="primary" @click="addsalesorder" icon="el-icon-document-copy">选单</el-button>
        <el-row>
          <div class="border" style="margin-bottom: 20px">
            <el-row>
              <el-col :span="6">
                <el-form-item label="单据编号" prop="DocNo">
                  <el-input v-model="data.DocNo" :placeholder="readonly ? '' : '请输入单据编号'" :disabled="readonly" v-if="noEdit"></el-input>
                  <span v-else>{{ data.DocNo }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="单据日期" prop="DocDate">
                  <el-date-picker
                    v-model="data.DocDate"
                    :placeholder="readonly ? '' : '请选择日期'"
                    value-format="yyyy-MM-dd"
                    :clearable="false"
                    :editable="false"
                    v-if="!readonly"
                  ></el-date-picker>
                  <span v-else>{{ data.DocDate.split(' ')[0] }}</span>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="供应商" prop="SupplierId">
                  <supplier @restaurants="setSupplier" :state="data.SupplierName" />
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="仓库" prop="WarehouseId">
                  <el-input @focus="addwarehouse" readonly v-model="data.WarehouseName" :disabled="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="业务员" prop="ClerkName">
                  <el-input v-model="data.ClerkName" @focus="addEmp" readonly style="width: 220px" :disabled="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="票据类型" prop="InvoiceType">
                  <invoice-select v-model="data.InvoiceType" @change="invoiceChange" :clearable="false" />
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="data.NeedInvoice">
                <el-form-item label="发票号码" prop="InvoiceNo">
                  <el-input v-model="data.InvoiceNo" :placeholder="readonly ? '' : '请输入发票号码'" :disabled="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6" v-if="data.NeedInvoice">
                <el-form-item label="发票金额" prop="InvoiceAmount">
                  <el-input v-model="data.InvoiceAmount" :placeholder="readonly ? '' : '请输入发票金额'" :disabled="readonly"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="折扣金额" prop="DiscountAmount">
                  <el-input type="number" v-model="data.DiscountAmount" :placeholder="0" :disabled="readonly" @input="reTotal"></el-input>
                  <!-- <span>{{ $commonJs.greaterNum(Math.floor(data.DiscountAmount*100)/100) }}</span> -->
                </el-form-item>
              </el-col>
              <el-col :span="24">
                <el-form-item label="备注" prop="Remark">
                  <el-input type="textarea" v-model="data.Remark" :placeholder="readonly ? '' : '请输入备注'" :disabled="readonly"></el-input>
                </el-form-item>
              </el-col>
            </el-row>
          </div>
          <dialog-list ref="dialogList" :disposeTax="DisposeTax" :info="data" :readonly="readonly" @getList="getList" />
          <el-col :span="6">
            <el-form-item label="无税金额" prop="NoTaxAmount">
              <span>{{ $commonJs.toThousands(data.NoTaxAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="税额" prop="TaxAmount">
              <span>{{ $commonJs.toThousands(data.TaxAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="进货金额" prop="TotalAmount">
              <span>{{ $commonJs.toThousands(data.TotalAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="付款金额" prop="PayAmount">
              <span>{{ $commonJs.toThousands(data.PayAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="剩余金额" prop="RemainAmount">
              <span>{{ $commonJs.toThousands(data.RemainAmount) }}</span>
            </el-form-item>
          </el-col>
          <el-col :span="6">
            <el-form-item label="折后金额" prop="Amount">
              <span>{{ $commonJs.toThousands(data.Amount) }}</span>
            </el-form-item>
          </el-col>
          <el-row>
            <el-row>
              <el-col :span="24">
                <el-divider />
                <span style="margin-left: 16px; line-height: 50px">付款信息</span>
                <el-button type="primary" icon="el-icon-plus" circle @click="add" v-if="!readonly" style="float: right; margin: 10px 15px 10px 0"></el-button>
              </el-col>
            </el-row>
            <el-row v-for="(item, index) in recList" :key="index">
              <el-col :span="6">
                <el-form-item label="结算方式" prop="SettleId">
                  <el-select v-model="item.SettleId" :placeholder="readonly ? '' : '请选择'" clearable :disabled="readonly" @change="saChange(index)">
                    <el-option v-for="set in settleList" :key="set.SettleId" :label="set.SettleName" :value="set.SettleId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="付款账号" prop="AccountId">
                  <el-select v-model="item.AccountId" :placeholder="readonly ? '' : '请选择'" clearable :disabled="readonly" @change="saChange(index)">
                    <el-option v-for="acc in accountList" :key="acc.AccountId" :label="acc.Bank + acc.AccountNumber" :value="acc.AccountId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="付款金额" prop="PayAmount">
                  <el-input
                    v-model="item.PayAmount"
                    type="number"
                    @blur="onBlur(item, 'PayAmount')"
                    @focus="onFocus(item, 'PayAmount')"
                    :disabled="readonly"
                    @input="recChange(index)"
                  ></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-link :underline="false" @click="del(index)" v-if="!readonly">
                  <i class="el-icon-delete" style="margin-left: 30px; line-height: 30px; font-size: 18px"></i>
                </el-link>
              </el-col>
            </el-row>
          </el-row>
          <div v-if="false">
            <el-col :span="24">
              <el-divider />
              <el-button type="primary" style="float: left; margin-bottom: 20px">费用分摊</el-button>
            </el-col>
            <el-row>
              <el-col :span="6">
                <el-form-item label="费用结算单位" prop="PayAmount">
                  <el-input v-model="data.unit" type="number" :disabled="readonly" style="width: 193px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="票据类型" prop="PayAmount">
                  <el-input v-model="data.type" type="number" :disabled="readonly" style="width: 193px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-button type="primary" icon="el-icon-plus" circle @click="addMoney" v-if="!readonly" style="margin: 0px 15px 10px 30px"></el-button>
              </el-col>
            </el-row>
            <el-row></el-row>
            <el-row v-for="(item, index) in recMList" :key="index">
              <el-col :span="6">
                <el-form-item label="费用类型" prop="SettleId">
                  <el-select v-model="item.SettleId" :placeholder="readonly ? '' : '请选择'" clearable :disabled="readonly" @change="saChange(index)">
                    <el-option v-for="set in settleList" :key="set.SettleId" :label="set.SettleName" :value="set.SettleId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="付款金额" prop="PayAmount">
                  <el-input v-model="item.PayAmount" type="number" :disabled="readonly" @input="recChange(index)" style="width: 193px"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-link :underline="false" @click="delM(index)" v-if="!readonly">
                  <i class="el-icon-delete" style="margin-left: 30px; line-height: 30px; font-size: 18px"></i>
                </el-link>
              </el-col>
            </el-row>
          </div>

          <el-row v-if="false">
            <el-row>
              <el-col :span="24">
                <el-divider />
                <span style="margin-left: 16px; line-height: 50px">费用分摊付款信息</span>
                <el-button type="primary" icon="el-icon-plus" circle @click="add" v-if="!readonly" style="float: right; margin: 10px 15px 10px 0"></el-button>
              </el-col>
            </el-row>
            <el-row v-for="(item, index) in recList" :key="index">
              <el-col :span="6">
                <el-form-item label="结算方式" prop="SettleId">
                  <el-select v-model="item.SettleId" :placeholder="readonly ? '' : '请选择'" clearable :disabled="readonly" @change="saChange(index)">
                    <el-option v-for="set in settleList" :key="set.SettleId" :label="set.SettleName" :value="set.SettleId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="6">
                <el-form-item label="付款账号" prop="AccountId">
                  <el-select v-model="item.AccountId" :placeholder="readonly ? '' : '请选择'" clearable :disabled="readonly" @change="saChange(index)">
                    <el-option v-for="acc in accountList" :key="acc.AccountId" :label="acc.AccountName" :value="acc.AccountId"></el-option>
                  </el-select>
                </el-form-item>
              </el-col>
              <el-col :span="5">
                <el-form-item label="付款金额" prop="PayAmount">
                  <el-input v-model="item.PayAmount" type="number" :disabled="readonly" @input="recChange(index)"></el-input>
                </el-form-item>
              </el-col>
              <el-col :span="1">
                <el-link :underline="false" @click="del(index)" v-if="!readonly">
                  <i class="el-icon-delete" style="margin-left: 30px; line-height: 30px; font-size: 18px"></i>
                </el-link>
              </el-col>
            </el-row>
          </el-row>
        </el-row>
      </template>
      <template slot="footer">
        <el-button type="danger" @click="cancelExamine" v-if="data.Status == 2 && canExa">弃 审</el-button>
        <el-button type="success" @click="examine" v-else-if="canExa">通 过</el-button>
        <el-button @click="close" v-if="readonly">关 闭</el-button>
      </template>
    </common-dialog>
    <emp-dialog ref="empDialog" in-dialog selectable @select="setEmp" />

    <warehouse-dialog ref="warehouseDialog" in-dialog selectable @select="setWarehouse" title="仓库列表" :typeList="[1, 2]" />
    <customer-dialog ref="customerDialog" in-dialog selectable @select="setUnit" title="选择采购订单" />
  </div>
</template>
<script>
import editDialogMixin from '@/mixins/editDialog'
import commonDialog from '@/components/common/dialog'
import dialogList from './dialogList'
import empDialog from '@/components/sales/business/empDialog'
import warehouseDialog from '@/components/basicinfo/basic/warehouse/listDialog'
import customerDialog from '@/components/basicinfo/basic/logistics/purchase/listDialog'
import invoiceSelect from '@/components/basedoc/invoice/select'
import supplier from '@/components/common/supplier/supplier'
export default {
  props: {
    DisposeTax: {
      type: [String, Number],
      default: ''
    }
  },
  mixins: [editDialogMixin],
  components: {
    commonDialog,
    dialogList,
    empDialog,
    warehouseDialog,
    customerDialog,
    invoiceSelect,
    supplier
  },
  data() {
    return {
      data: {
        DocId: 0,
        DocType: 0,
        SupplierId: null,
        SupplierName: '',
        WarehouseName: '',
        WarehouseId: '',
        DocNo: '',
        DocDate: '',
        Status: 0,
        // Source: 0,
        Remark: '',
        NoTaxAmount: 0,
        TaxAmount: 0,
        PayAmount: 0,
        Amount: 0,
        RemainAmount: 0,
        TotalAmount: 0,
        DiscountAmount: 0,
        // ReceiptConditionId: null,
        ClerkName: '',
        ClerkId: 0,
        //----
        NeedInvoice: true,
        InvoiceType: null,
        DocDateEnd: '',
        InvoiceNo: '',
        InvoiceAmount: '',
        unit: null,
        type: null,
        //  DisposeTax: "",
        //  CostUnitId: "",
        //  CostInvoiceType: "",
        //  ShareWay: "",
        //  Status: "",
        //  PayStatus: "",
        //  InvoiceStatus: "",
        //  AddTime: "",
        //    UpdateTime: "",
        //  AddUserId: "",
        //  UpdateUserId: "",
        //    EntId: "",
        Pays: [],
        Goods: []
      },
      // DisposeTax:null,
      noEdit: false,
      canExa: false,
      recList: [],
      recMList: [],
      recDel: [],
      tableData: [],
      accountList: [],
      settleList: [],
      recCon: [],
      cList: [],
      eqType: null,
      // PriAdjustEmpList: [],
      api: require('@/api/purchase/stock').default,
      recApi: require('@/api/sy/RecCon').default,
      settleApi: require('@/api/sale/settle').default,
      accountApi: require('@/api/sale/account').default,
      billApi: require('@/api/sy/bill').default,
      optApi: require('@/api/sy/opt').default,
      readonly: false,
      rules: {
        Source: [{ required: true, message: '订单来源不能为空' }],
        // WarehouseId: [{ required: true, message: "仓库不能为空" }],
        InvoiceType: [{ required: true, message: '票据类型不能为空' }],
        InvoiceNo: [{ required: true, message: '发票号码不能为空' }],
        InvoiceAmount: [{ required: true, message: '发票金额不能为空' }],
        SupplierId: [{ required: true, message: '供应商不能为空' }]
      }
    }
  },
  beforeMount() {
    let date = new Date()
    date.setTime(date.getTime())
    let today = date.getFullYear() + '-' + (date.getMonth() + 1) + '-' + date.getDate()
    if (!this.data.DocDate) {
      this.data.DocDate = today
    }
    this.settleApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.settleList = res.Data
    })
    this.accountApi.list({ Status: 1, PageIndex: 1, PageSize: 100 }).then(res => {
      this.accountList = res.Data
    })
    this.recApi.list({ PageIndex: 1, PageSize: 100 }).then(res => {
      this.recCon = res.Data
    })
    // this.optApi.getStandingStock().then(res => {
    //   this.eqType = res.Data
    // })
    // this.optApi.list({ Code: "PURCHASE" }).then(res => {
    //   res.Data.forEach(e=>{
    //     if(e.OptText=='DisposeTax'){
    //       this.DisposeTax = e.OptValue
    //     }
    //   })
    // })
  },
  methods: {
    setSupplier(data) {
      this.data.SupplierId = data.TradeUnitId
      this.data.SupplierName = data.TradeUnitName

      let tableData = this.$refs.dialogList.tableData

      let newData = tableData.filter(x => {
        if (x.GoodsId > 0) {
          return x
        }
      })

      if (newData.length > 0 && this.data.SupplierId > 0) {
        this.$confirm('是否更新商品报价', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          var ids = newData.map(x => x.GoodsId)
          console.log(ids)
          if (ids.length > 0) {
            //获取所有商品报价
            this.api.GoodsOfferList({ SupplierId: this.data.SupplierId, GoodsIds: ids }).then(res => {
              if (res.Data.length > 0) {
                res.Data.forEach(x => {
                  tableData.forEach((g, index, tables) => {
                    if (g.GoodsId == x.GoodsId) {
                      tables[index].T = tables[index].T == 0 ? 0 : 1
                      tables[index].Offer = x.GoodsOffer
                      tables[index].Price = x.GoodsOffer

                      // 更新金额
                      let dis = tables[index].Discount > 0 ? Number(tables[index].Discount) : 100;
                      let rate = tables[index].TaxRate ? Number(tables[index].TaxRate) : 0;
                      if (dis != 100) {
                        var price1 = (tables[index].Offer * (dis / 100) * (1 + rate / 100)).toFixed(2);
                        tables[index].Price = price1;
                        tables[index].NoTaxAmount = (tables[index].Price * tables[index].Quantity1).toFixed(4) || 0
                      } else {
                        var price2 = (tables[index].Offer * (1 + rate / 100)).toFixed(4);
                        tables[index].NoTaxAmount = (price2 * tables[index].Quantity1).toFixed(4) || 0
                      }
                      this.getList(this.$refs.dialogList.tableData)
                    }
                  })
                })
              }
            })
          }
        })
      }
    },
    onBlur(row, type) {
      if (row[type] == null) row[type] = 0
    },
    onFocus(row, type) {
      if (row[type] == 0) row[type] = null
    },
    invoiceChange(e, data, type) {
      this.data.NeedInvoice = data.NeedInvoice
      if (!data.NeedInvoice) {
        this.data.InvoiceNo = ''
        this.data.InvoiceAmount = ''
      }
      this.$nextTick(() => {
        console.log('change', data, type)
        this.$refs.dialogList.isTax=data.DefTaxRate>0;
        this.$refs.dialogList.setDefTaxRate(data.DefTaxRate, type)
      })
    },
    setUnit(e) {
      console.log(e)
      let tableData = this.$refs.dialogList.tableData
      if (!tableData.some(v => v.GoodsId)) {
        this.$refs.dialogList.tableData = []
      }
      e.list.forEach(v => {
        this.$refs.dialogList.setGoods(v)
      })
      this.data.SupplierId = e.Supplier.SupplierId
      this.data.SupplierName = e.Supplier.SupplierName
    },
    addsalesorder(e) {
      this.$refs.customerDialog.open().then(that => {
        that.getData({ Status: 2 })
      })
    },
    addwarehouse(e) {
      this.$refs.warehouseDialog.open().then(that => {
        that.getData({})
        that.getTree()
      })
    },
    setWarehouse(e) {
      this.data.WarehouseId = e.WarehouseId
      this.data.WarehouseName = e.WarehouseName
      this.$refs.dialogList.setTableWarehouse(e)
      // this.data.CustomerType = e.TradeUnitType
    },
    reTotal(e) {
      var total = this.data.TotalAmount || 0
      total = parseFloat(total)
      if (total == 0) {
        total = this.data.Amount || 0
      }
      if (total != 0) {
        var amount = Number(total.toFixed(2)) - Number(this.data.DiscountAmount || 0)
        this.data.Amount = amount.toFixed(2)
        this.data.RemainAmount = (Number(this.data.Amount) - Number(this.data.PayAmount)).toFixed(2)
      }
    },
    getList(list) {
      console.log('getList', list)
      this.tableData = list
      let Amount = null
      let TaxAmount = null
      let PayAmount = this.data.PayAmount || 0
      let TotalAmount = null
      list.forEach(item => {
        if (item.T != 2) {
          Amount += Number(Number(item.Amount).toFixed(2))
          TaxAmount += Number(Number(item.TaxAmount).toFixed(2))
          TotalAmount += Number(Number(item.Amount).toFixed(2))
        }
      })
      this.data.TotalAmount = Number(TotalAmount).toFixed(2)
      this.data.Amount = Number(Amount - Number(this.data.DiscountAmount || 0)).toFixed(2)
      this.data.TaxAmount = Number(TaxAmount).toFixed(2)
      this.data.NoTaxAmount = Number(Amount - TaxAmount).toFixed(2)
      this.data.RemainAmount = Number(Number(this.data.Amount) - Number(PayAmount)).toFixed(2)
    },
    saChange(index) {
      if (this.recList[index].OrderReceiptId && this.recList !== 1) {
        this.recList[index].T = 1
      }
    },
    recChange(index, type) {
      let PayAmount = 0
      let Amount = this.data.Amount
      if (!Amount) {
        Amount = 0
      }
      this.recList.forEach(item => {
        if (item.PayAmount) {
          PayAmount += Number(item.PayAmount)
        }
      })
      if (type != 'del') {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 1
        }
      }
      this.data.PayAmount = Number(PayAmount)
      this.data.RemainAmount = this.data.Amount - this.data.PayAmount
    },
    add() {
      this.recList.push({
        T: 0,
        DocReceiptId: 0,
        OrderReceiptId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        AccountId: null,
        PayAmount: 0,
        AddTime: this.data.DocDate
      })
    },
    addMoney() {
      this.recMList.push({
        T: 0,
        DocReceiptId: 0,
        OrderReceiptId: 0,
        DocId: this.data.DocId,
        SettleId: null,
        AccountId: null,
        PayAmount: 0,
        AddTime: this.data.DocDate
      })
    },
    del(index) {
      this.$confirm('确认删除该行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.recList[index].T !== 0) {
          this.recList[index].T = 2
          this.recDel.push(this.recList[index])
        }
        this.recList.splice(index, 1)
        this.recChange(index, 'del')
      })
    },
    delM(index) {
      this.$confirm('确认删除该行数据吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        if (this.recMList[index].T !== 0) {
          this.recMList[index].T = 2
          this.recDel.push(this.recMList[index])
        }
        this.recMList.splice(index, 1)
        this.recChange(index, 'del')
      })
    },
    addEmp() {
      // let ids = this.PriAdjustEmpList.map((x) => x.EmpId);
      this.$refs.empDialog.open().then(that => {
        that.getData({ Status: 1 })
      })
    },
    setEmp(e) {
      this.data.ClerkId = e.EmpId
      this.data.ClerkName = e.EmpName
    },
    examine() {
      this.$confirm('确认通过吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.examine(this.data.DocId).then(res => {
          if (res.Code == 0) {
            this.$message.success('审核成功')
            this.readonly = true
            this.close()
            this.$emit('close-saved')
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    cancelExamine() {
      this.$confirm('确认弃审吗？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.api.cancelExamine(this.data.DocId).then(res => {
          if (res.Code == 0) {
            this.$message.success('弃审成功')
            this.readonly = false
            this.close()
            this.$emit('close-saved')
          } else {
            this.$message.error(res.Msg)
          }
        })
      })
    },
    onCreateOpened() {
      this.readonly = false
      this.canExa = false
      this.data.InvoiceType = 1
      let d = { InvoiceTypeId: 1, InvoiceTypeName: '收据', Point: 0.0, Sort: 0, Status: 1, DefTaxRate: 0.0, EntId: 1, NeedInvoice: false }
      this.invoiceChange('', d, true)
      this.cList = JSON.parse(sessionStorage.getItem('cList'))
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.tableData = [
        {
          T: 0,
          OrderGoodsId: 0,
          DocId: 0,
          BarCode: '',
          GoodsName: '',
          GoodsId: '',
          Model: '',
          UnitId: 0,
          UnitName: '',
          Quantity: 0,
          Quantity1: 0,
          Quantity2: 0,
          BatchNo: '',
          Offer: 0,
          Discount: 100,
          Price: 0,
          NoTaxPrice: 0,
          ExistQuantity: 0,
          AvailableQuantity: 0,
          TaxRate: this.DefTaxRate,
          TaxAmount: 0,
          Amount: 0,
          NoTaxAmount: 0,
          PromotionType: 0,
          PromotionId: 0,
          ReferenceCost: 0,
          GrossProfit: 0,
          Remark: '',
          Thumbnail: '',
          OutQuantity: 0,
          AddTime: '',
          WholesalePrice: '',
          UnitId: '',
          UnitId1: '',
          UnitId2: ''
        }
      ]
      this.recList = []
      var user = this.$store.state.user
      if (user) {
        this.data.ClerkId = user.empId
        this.data.ClerkName = user.name
      }
      this.billApi.getDefaultSerialNo('进货单').then(res => {
        if (res.Code == 0 && res.Data) {
          this.data.DocNo = res.Data
        } else if (res.Code == 0) {
          this.noEdit = true
        } else {
          this.$message.warning(res.Msg)
        }
      })
      this.readonly = true
      this.$nextTick(() => {
        this.readonly = false
      })
    },
    onEditOpened(row) {
      if (sessionStorage.getItem('check') === '1') {
        this.canExa = true
        this.readonly = true
        sessionStorage.removeItem('check')
      } else {
        this.canExa = false
        this.readonly = false
      }
      this.$refs.dialogList.tableDel = []
      this.$refs.dialogList.getData()
      this.cList = JSON.parse(sessionStorage.getItem('cList'))
      if (this.data.ReceiptConditionId == 0) {
        this.data.ReceiptConditionId = null
      }
      this.recList = this.data.Pays
      // this.api.getReceiptList({DocId:this.data.DocId}).then(res => {
      //   res.Data.forEach(item => {
      //     if(item.SettleId == 0) {
      //       item.SettleId = null
      //     }
      //     if(item.AccountId == 0) {
      //       item.AccountId = null
      //     }
      //   })
      //   this.recList = res.Data
      // })
      console.log('onEditOpened row', row)

      this.$nextTick(() => {
        if (row.InvoiceType > 1) {
          this.$refs.dialogList.setDefTaxRate(1, false)
        } else {
          this.$refs.dialogList.setDefTaxRate(0, true)
        }
      })
    },
    onBeforeSave() {
      // return false
      let tableData = this.$refs.dialogList.tableData
      let tableDel = this.$refs.dialogList.tableDel
      let tb = []
      if (tableData.length == 0 || !tableData.some(v => v.GoodsId)) {
        this.$message.error('请填写商品列表')
        return false
      }
      for (var i = 0; i < tableData.length; i++) {
        if (tableData[i].GoodsId) {
          if (!(tableData[i].Quantity > 0)) {
            this.$message.error('请填写正确数量')
            return false
          }
          if (!tableData[i].Discount) {
            tableData[i].Discount = 100
          }
          if (this.eqType === 1) {
            if (tableData[i].Quantity > tableData[i].ExistQuantity) {
              this.$message.warning('存在商品数量大于现存量')
            }
          }
          if (this.eqType === 2) {
            if (tableData[i].Quantity > tableData[i].ExistQuantity) {
              this.$message.error('数量不可大于现存量')
              return false
            }
          }
          if (!tableData[i].TaxRate) {
            tableData[i].TaxRate = 0
          }
          if (!tableData[i].Discount) {
            tableData[i].Discount = 100
          }
          if (!tableData[i].UnitName) {
            tableData[i].UnitName = ''
          }
          if (tableData[i].T === 0 || tableData[i].T === 1) {
            this.$delete(tableData[i], 'unit')
            this.$delete(tableData[i], 'Rate1')
            this.$delete(tableData[i], 'Rate2')
            tb.push(tableData[i])
          }
        }
      }
      //
      this.data.Goods = tb.concat(tableDel)
      // if(!this.data.RemainAmount&&this.data.RemainAmount!==0||this.recList.length==0) {
      //   this.$message.error("请填写付款信息");
      //   return false
      // }
      if (this.data.ReceiptConditionId === null) {
        this.data.ReceiptConditionId = 0
      }
      let rec = []
      this.recList.forEach(item => {
        if (item.T || item.T === 0) {
          rec.push(item)
        }
      })
      for (var i = 0; i < rec.length; i++) {
        if (!rec[i].SettleId) {
          this.$message.error('请选择结算方式')
          return false
        }
        if (!rec[i].AccountId) {
          this.$message.error('请选择收款账号')
          return false
        }
        if (!(rec[i].PayAmount > 0)) {
          this.$message.error('请填写正确收款金额')
          return false
        }
      }
      this.data.Pays = rec.concat(this.recDel)
      // this.data.Receipts.forEach(item => {
      //   if(!item.SettleId) {
      //     item.SettleId = 0
      //   }
      //   if(!item.AccountId) {
      //     item.AccountId = 0
      //   }
      // })

      return true
    }
  }
}
</script>
<style lang="scss">
.is-disabled {
  input,
  textarea {
    background-color: #fff !important;
    color: #333 !important;
  }
}
.border {
  padding: 15px 25px 0 0;
  margin-top: 15px;
}
</style>
